import type { FaireProductEntity } from "../../entity_types/product";

export const p_4tq4kfwebp: FaireProductEntity = {
  token: "p_4tq4kfwebp",
  type: "product",
  name: "Raised in a barn Cow Country Western Farm Kids Trucker Hat",
  brandToken: "b_tzj57mbuf2",
  brandName: "Barefoot Baby",
  imageUrl:
    "https://cdn.faire.com/fastly/8a9a675fc7127ecb659ba36d43d9a14a9046630eb96f813a9b3f81f103482e1d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a3d9085b85be8e74d9739fdbf922feebb42259ced54a8407e49528c66a3d6c50.jpeg",
    "https://cdn.faire.com/fastly/fa528af44d7d7db1494a1d5a601f40757e4f4e0c84d73233473fbb8cc8457508.jpeg",
    "https://cdn.faire.com/fastly/dcd3fd5e0f7e62d103370c79f61f32ceb768e8cd7956eb2e403246c5bc001e4a.jpeg",
    "https://cdn.faire.com/fastly/4b97ff14f28ae40da3583dde44d4603cfa1bb7e2b89829cfb544f66296c693e0.jpeg",
    "https://cdn.faire.com/fastly/10bafa73a8798f925063b554270b63e4b3154d1c07f2ae73597a79977aa3d6de.jpeg",
    "https://cdn.faire.com/fastly/b7374319aa2fe1e25e1fc9595600f7d722cb83e92d39fbdf4b597a1466f48715.jpeg",
    "https://cdn.faire.com/fastly/9d97d9778899ab8a567a4c15747d4f588fd05cd2639c2db2fd5c8a5835affd2e.jpeg",
    "https://cdn.faire.com/fastly/ec6837888e5353fb52b4f1885455a2b72ac93431c6904f31e5781e49e13a0598.jpeg",
  ],
  priceDollars: 11,
  description:
    '"Raised in a barn" Cow, mesh adjustable snapback hat\n\nDoes your kid love cows and farm life? In pairing original artwork with a leather patch and high quality craftsmanship, the hat is perfect for all your days at the barn!\n\n**SIZING INFO**\nFits 18”-21” head circumference and have a mesh backing. The adjustable straps fit head circumference of 18-21 inches and fit best on ages three and up. Measure your child\'s head circumference to be sure! Every child is different.\n\nWHAT MAKES US DIFFERENT\n- We are a family company, woman and mom owned!\n- Our designs are all original artwork created from the inspiration we draw from our outdoor-loving kids!\n- Our clothing is hand-printed in small batches in our shop right in Western North Carolina.\n\nBFB Mission: We strive to make quality clothing your mini adventurers will love. Whether they are on the farm, hiking mountains, or just running in the grass, we hope they live life barefoot!',
  tags: [],
  msrpDollars: 21.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:13.538Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
